module.exports = new __parcel__URL__("kitten3.46866835.png").toString();